import { useEffect, useState } from "react";
import { databases, DATABASE_ID, COLLECTIONS } from "../lib/appwriteClient";
import { ID } from "appwrite";

export function EventManager() {
  const [events, setEvents] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [rules, setRules] = useState("");
  const [prizes, setPrizes] = useState("");
  const [editingId, setEditingId] = useState(null);

  // 🔄 FETCH EVENTS
  const fetchEvents = async () => {
    try {
      const res = await databases.listDocuments(
        DATABASE_ID,
        COLLECTIONS.EVENTS,
      );
      setEvents(res.documents);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  // ➕ CREATE or UPDATE
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editingId) {
        // ✏️ UPDATE
        await databases.updateDocument(
          DATABASE_ID,
          COLLECTIONS.EVENTS,
          editingId,
          {
            name,
            description,
            rules,
            prizes,
            order: "1",
            is_active: true,
          },
        );
      } else {
        // ➕ CREATE
        await databases.createDocument(
          DATABASE_ID,
          COLLECTIONS.EVENTS,
          ID.unique(),
          {
            name,
            description,
            rules,
            prizes,
            order: "1",
            is_active: true,
          },
        );
      }

      // reset form
      setName("");
      setDescription("");
      setRules("");
      setPrizes("");
      setEditingId(null);

      fetchEvents();
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  // 🗑 DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this event?")) return;

    try {
      await databases.deleteDocument(DATABASE_ID, COLLECTIONS.EVENTS, id);
      fetchEvents();
    } catch (error) {
      console.error(error);
      alert("Delete failed");
    }
  };

  // ✏️ EDIT
  const handleEdit = (event) => {
    setName(event.name);
    setDescription(event.description);
    setRules(event.rules);
    setPrizes(event.prizes);
    setEditingId(event.$id);
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">
        {editingId ? "Edit Event" : "Create Event"}
      </h2>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="space-y-3 mb-6">
        <input
          type="text"
          placeholder="Event Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full border p-2 rounded"
          required
        />

        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full border p-2 rounded"
        />

        <textarea
          placeholder="Rules"
          value={rules}
          onChange={(e) => setRules(e.target.value)}
          className="w-full border p-2 rounded"
        />

        <textarea
          placeholder="Prizes"
          value={prizes}
          onChange={(e) => setPrizes(e.target.value)}
          className="w-full border p-2 rounded"
        />

        <button className="bg-blue-600 text-white px-4 py-2 rounded">
          {editingId ? "Update Event" : "Create Event"}
        </button>
      </form>

      {/* EVENT LIST */}
      <h3 className="text-lg font-semibold mb-2">All Events</h3>

      <ul className="space-y-3">
        {events.map((event) => (
          <li key={event.$id} className="border p-4 rounded">
            <strong>{event.name}</strong>

            <p className="text-sm text-gray-600">{event.description}</p>

            <p className="text-xs text-gray-500">Rules: {event.rules}</p>

            <p className="text-xs text-green-600">Prizes: {event.prizes}</p>

            {/* ACTION BUTTONS */}
            <div className="mt-3 flex gap-2">
              <button
                onClick={() => handleEdit(event)}
                className="bg-yellow-500 text-white px-3 py-1 rounded"
              >
                Edit
              </button>

              <button
                onClick={() => handleDelete(event.$id)}
                className="bg-red-600 text-white px-3 py-1 rounded"
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
